/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PastWinnersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PastWinnersQuery = { __typename?: 'Query', pastWinners?: Array<{ __typename?: 'PastWinner', id: string, name?: string | null, postcode?: string | null, prize?: string | null, heading?: string | null, content?: string | null } | null> | null };


export const PastWinnersDocument = gql`
    query pastWinners {
  pastWinners {
    id
    name
    postcode
    prize
    heading
    content
  }
}
    `;

/**
 * __usePastWinnersQuery__
 *
 * To run a query within a React component, call `usePastWinnersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePastWinnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePastWinnersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePastWinnersQuery(baseOptions?: Apollo.QueryHookOptions<PastWinnersQuery, PastWinnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PastWinnersQuery, PastWinnersQueryVariables>(PastWinnersDocument, options);
      }
export function usePastWinnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PastWinnersQuery, PastWinnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PastWinnersQuery, PastWinnersQueryVariables>(PastWinnersDocument, options);
        }
export function usePastWinnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PastWinnersQuery, PastWinnersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PastWinnersQuery, PastWinnersQueryVariables>(PastWinnersDocument, options);
        }
export type PastWinnersQueryHookResult = ReturnType<typeof usePastWinnersQuery>;
export type PastWinnersLazyQueryHookResult = ReturnType<typeof usePastWinnersLazyQuery>;
export type PastWinnersSuspenseQueryHookResult = ReturnType<typeof usePastWinnersSuspenseQuery>;
export type PastWinnersQueryResult = Apollo.QueryResult<PastWinnersQuery, PastWinnersQueryVariables>;